"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutsideClickWrapper = exports.MenuWrapper = exports.MenuTitle = exports.DropDownButton = exports.StyledArrowDropDown = exports.StyledDropDown = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DropdownArrow = _interopRequireDefault(require("../../Shared/DropdownArrow"));

var _DropdownContent = _interopRequireDefault(require("../../Shared/DropdownContent"));

var _MenuButton = _interopRequireDefault(require("../../Shared/MenuButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledDropDown = (0, _styledComponents.default)(_DropdownContent.default).withConfig({
  displayName: "HeaderFinancingstyles__StyledDropDown",
  componentId: "cj2ajm-0"
})(["right:-4px;top:72px;border-radius:3px;", ";"], function (props) {
  return props.isDropdownExpanded && 'display: block;';
});
exports.StyledDropDown = StyledDropDown;
var StyledArrowDropDown = (0, _styledComponents.default)(_DropdownArrow.default).withConfig({
  displayName: "HeaderFinancingstyles__StyledArrowDropDown",
  componentId: "cj2ajm-1"
})(["fill:", ";margin-top:1px;width:10px;"], function (_ref) {
  var isDropdownExpanded = _ref.isDropdownExpanded,
      theme = _ref.theme,
      isActive = _ref.isActive;
  return isDropdownExpanded || isActive ? theme.carvana.blue.primary : theme.carvana.blue.dark;
});
exports.StyledArrowDropDown = StyledArrowDropDown;
var DropDownButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "HeaderFinancingstyles__DropDownButton",
  componentId: "cj2ajm-2"
})(["height:49px;justify-content:flex-start;padding:0px 20px 0 21px;width:100%;letter-spacing:0;"]);
exports.DropDownButton = DropDownButton;

var MenuTitle = _styledComponents.default.span.attrs({
  "data-qa": "menu-title"
}).withConfig({
  displayName: "HeaderFinancingstyles__MenuTitle",
  componentId: "cj2ajm-3"
})(["color:", ";"], function (_ref2) {
  var isDropdownExpanded = _ref2.isDropdownExpanded,
      theme = _ref2.theme,
      isActive = _ref2.isActive;
  return isDropdownExpanded || isActive ? theme.carvana.blue.primary : theme.carvana.blue.dark;
});

exports.MenuTitle = MenuTitle;

var MenuWrapper = _styledComponents.default.div.attrs({
  "data-qa": "menu-wrapper"
}).withConfig({
  displayName: "HeaderFinancingstyles__MenuWrapper",
  componentId: "cj2ajm-4"
})(["display:inline-flex;padding:7px 0 0;position:relative;", ";border-bottom:5px solid transparent;&:before{position:absolute;content:'';width:0;height:0;border:7px solid transparent;margin:auto;bottom:-15px;left:calc(50% - 6px);}", ""], function (props) {
  return props.isDropdownExpanded && 'z-index: 101;';
}, function (props) {
  return props.isActive && "\n    color: ".concat(props.theme.carvana.blue.primary, ";\n    border-color: ").concat(props.theme.carvana.blue.primary, ";\n\n    &:before {\n      border-top: 4px solid ").concat(props.theme.carvana.blue.primary, ";\n    }\n  ");
});

exports.MenuWrapper = MenuWrapper;

var OutsideClickWrapper = _styledComponents.default.div.attrs({
  "data-qa": "outside-click-wrapper"
}).withConfig({
  displayName: "HeaderFinancingstyles__OutsideClickWrapper",
  componentId: "cj2ajm-5"
})(["display:none;", ";background:none;position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:99;"], function (props) {
  return props.isDropdownExpanded && 'display: block;';
});

exports.OutsideClickWrapper = OutsideClickWrapper;